import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../core/form-generator";
import { getProductFormConfig } from "./config";
import { Box, Grid } from "@mui/material";
import { handleFormValidation, PAGE_LIMIT } from "../../utils";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CustomButtonComponent from "../../core/custom-button";
import { HTTP_METHODS, invokeApi, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import InputWithAction from "../../pages/admin/literature/service-information/input-with-action";
import CustomTable from "../../core/custom-table";
import EditableTable from "./editable-table";
import SiFileUpload from "../../core/file-uploader";
import SiAutocomplete from "../../core/si-autocomplete";
const CreateProduct = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [listData, setListData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [oemsList, setOemsList] = useState([]);
  const [engineModelImg, setEngineModelImg] = useState("");
  let oemTimeout = null;

  const resetHandler = () => {
    toast.success("Updated Successfully");
    setFormData({});
    setIsCreate(false);
    loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
    setEngineModelImg("");
  };

  const submitHandler = () => {
    const isValid = handleFormValidation(
      getProductFormConfig(editData),
      setErrors,
      formData
    );
    if (isValid && tableData.length < 1) {
      toast.error("Add atleast one list number");
      return;
    }
    if (isValid) {
      const payload = {
        ...formData,
        oem: formData?.oem?.value,
        listData: tableData.map((ele) => {
          delete ele.id;
          return { ...ele };
        }),
      };
      if (engineModelImg) {
        payload["photo"] = engineModelImg;
      }
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.PRODUCTS}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              resetHandler();
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.PRODUCTS}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              resetHandler();
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const getOemList = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemsList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (editData?.id) {
      const { oem, engineModel, listData, photo } = editData;

      setFormData((prevVal) => ({
        ...prevVal,
        oem: oemsList.find((ele) => ele.value === oem?.id),
        engineModel,
      }));
      const listNumbers = listData.map((ele) => ele?.listNumber);
      setListData(listNumbers);
      setTableData(listData);
      setEngineModelImg(photo);
    }
  }, [editData, oemsList]);

  useEffect(() => {
    getOemList();
  }, []);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getProductFormConfig(oemsList)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          fieldGridSize={6}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <div style={{ width: "48%" }}>
            <p>List Numbers*</p>
            <InputWithAction
              updateStateFun={setListData}
              stateValue={listData}
              placeholder="Enter Engine Model"
            />
          </div>
          {listData?.length > 0 && (
            <div className="input-field-con">
              {listData?.map((lis, index) => {
                return (
                  <div
                    className={`chip-com-con purple-bg`}
                    style={{ width: "fit-content", marginRight: "10px " }}
                  >
                    <p>{lis} </p>
                    <CloseOutlinedIcon
                      onClick={() => {
                        const filteredList = listData?.filter(
                          (ele) => ele !== lis
                        );
                        setListData(filteredList);
                      }}
                      fontSize="small"
                      sx={{ ml: 1, cursor: "pointer" }}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </Box>
        <Box sx={{ mt: 5, mr: 3 }}>
          <EditableTable
            listData={listData}
            tableData={tableData}
            setTableData={setTableData}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 5,
            mb: 2,
            gridGap: "1rem",
            alignItems: "center",
          }}
        >
          <SiFileUpload
            fileTypes={["image/*"]}
            callBack={(newFile) => setEngineModelImg(newFile?.url)}
            id={null}
            title="Upload Product Image"
          />
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "150px" }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
        {engineModelImg && (
          <Box
            sx={{
              border: "1px solid lightGray",
              width: "fit-content",
              borderRadius: "5px",
              overflow: "hidden",
            }}
          >
            <img src={engineModelImg} alt="engine-model" width="100px" />
          </Box>
        )}
      </div>
    </div>
  );
};

export default CreateProduct;
